<template>
  <b-card no-body>
    <b-card-body>
      <b-row class="d-flex align-items-center">
        <b-col>
          <filter-card :get-data-list="filterDataList" />
        </b-col>
        <b-col
          v-if="canAdd"
          cols="12"
          md="auto"
        >
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      :busy="loading"
      :empty-text="emptyText"
      :show-empty="!!emptyText"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle" />
          <strong class="ml-2">Yükleniyor...</strong>
        </div>
      </template>
      <template #cell(title)="data">
        <b-link
          :to="$route.path + '/view/' + data.item.id"
          class="text-body d-block"
        >
          <div v-if="data.item.pcode">
            <b-badge
              variant="light-primary"
              size="sm"
            >
              {{ data.item.pcode }}
            </b-badge>
          </div>
          {{ data.item.title }}
          <div
            v-if="data.item.departments"
          >
            <b-badge variant="light-info">
              <feather-icon icon="FolderIcon" />
              {{ data.item.departments }}
            </b-badge>
          </div>
        </b-link>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <list-buttons
            :view-action="$route.path + '/view/' + data.item.id"
            :edit-action="$route.path + '/edit/' + data.item.id"
            :delete-action="removeData"
            :data-id="data.item.id"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-if="dataCounts > perPage"
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BSpinner, BLink, BBadge, BRow, BCol,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { hasPackageLimit } from '@/libs/packageLimits'
import listPagination from '@/mixins/listPagination'
import FilterCard from '@/views/Projects/Components/FilterCard.vue'

const tableName = 'projects'
export default {
  name: 'Index',
  components: {
    BBadge,
    BLink,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BSpinner,
    BRow,
    BCol,
    ListButtons,
    FilterCard,
  },
  mixins: [listPagination],
  data() {
    return {
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Başlık',
        },
        {
          key: 'teams',
          label: 'Ekip',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.pcode AS pcode`,
          'departments.title AS departments',
          'teams.title AS teams',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    canAdd() {
      return this.$can('read', 'PROJECTS_ADD') && hasPackageLimit('PROJECTS_MANAGE')
    },
    loading() {
      return this.$store.getters['projects/loading']
    },
    emptyText() {
      if (this.loading === true) {
        return 'Lütfen bekleyiniz...'
      }
      if (this.dataList.length === 0) {
        return 'İçerik bulunamadı.'
      }
      return null
    },
    dataList() {
      return this.$store.getters['projects/dataList']
    },
    dataCounts() {
      return this.$store.getters['projects/dataCounts']
    },
    saveData() {
      return this.$store.getters['projects/dataSaveStatus']
    },
    filterParams() {
      return this.$store.getters['projects/filterParams']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.dataQuery.start = (this.currentPage - 1) * this.perPage
      if (this.filterParams.keywords) {
        this.dataQuery.or_like = {
          'projects.title': this.filterParams.keywords,
          'projects.pcode': this.filterParams.keywords,
        }
      } else {
        delete this.dataQuery.or_like
      }
      this.$store.dispatch('projects/getDataList', this.dataQuery)
        .then(() => this.checkPageRange())
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('projects/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
